<bw-action-card-legacy (ctaClicked)="navigate(data.state)" [cardConfig]="actionCardConfig[data.state]"></bw-action-card-legacy>
